import { create } from "zustand";
import type { DocID } from "@/types";
import type {
  CampaignAudienceCriteria,
  CampaignAudienceType,
  CampaignTemplate,
  VariableMappingEntry,
} from "@/features/campaigns/types";

// Guarda o estado do Builder do disparo em massa (T7) e sobrevive à navegação
// builder ↔ revisão (T8) por ser um store zustand em memória — nenhuma
// persistência em localStorage: um reload de página descarta o rascunho
// (V1 não tem rascunho persistido, "criar ≡ disparar").
export interface CampaignBuilderState {
  /** Preenchido só em modo edição (T9) — null = criação de campanha nova. */
  editingCampaignDocumentId: DocID | null;
  name: string;
  audienceType: CampaignAudienceType;
  criteria: CampaignAudienceCriteria;
  template: CampaignTemplate | null;
  variableMapping: VariableMappingEntry[];
  /** Colunas do CSV enviado (upload-csv) — só relevante quando audienceType === "csv". */
  csvColumns: string[];
  scheduledAt: string | null;
}

export interface CampaignBuilderActions {
  setName: (name: string) => void;
  setAudienceType: (audienceType: CampaignAudienceType) => void;
  setCriteria: (criteria: CampaignAudienceCriteria) => void;
  setTemplate: (template: CampaignTemplate | null) => void;
  setVariableMapping: (variableMapping: VariableMappingEntry[]) => void;
  setCsvColumns: (csvColumns: string[]) => void;
  setScheduledAt: (scheduledAt: string | null) => void;
  setEditingCampaignDocumentId: (documentId: DocID | null) => void;
  reset: () => void;
}

const initialState: CampaignBuilderState = {
  editingCampaignDocumentId: null,
  name: "",
  audienceType: "tags",
  criteria: {},
  template: null,
  variableMapping: [],
  csvColumns: [],
  scheduledAt: null,
};

export const useCampaignBuilderStore = create<
  CampaignBuilderState & CampaignBuilderActions
>((set) => ({
  ...initialState,

  setName: (name) => set({ name }),
  setAudienceType: (audienceType) => set({ audienceType }),
  setCriteria: (criteria) => set({ criteria }),
  setTemplate: (template) => set({ template }),
  setVariableMapping: (variableMapping) => set({ variableMapping }),
  setCsvColumns: (csvColumns) => set({ csvColumns }),
  setScheduledAt: (scheduledAt) => set({ scheduledAt }),
  setEditingCampaignDocumentId: (editingCampaignDocumentId) =>
    set({ editingCampaignDocumentId }),
  reset: () => set(initialState),
}));
